import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';

const ImportHistoryModal = ({ isOpen, toggle, organization, configId }) => {
    const [imports, setImports] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isOpen && organization?.id && configId) {
            setLoading(true);
            axios.get(`/organization/${organization.id}/import`, {
                params: { csv_import_setting_id: configId, limit: 20 }
            })
            .then(res => {
                setImports(res.data?.data || []);
            })
            .finally(() => setLoading(false));
        }
    }, [isOpen, organization?.id, configId]);

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                Import History — Configuration #{configId}
            </ModalHeader>
            <ModalBody>
                {loading && <p>Loading...</p>}
                {!loading && imports.length === 0 && <p className="text-muted">No imports found.</p>}
                {!loading && imports.length > 0 && (
                    <>
                    <Table size="sm" className="table table--bordered">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>File Name</th>
                                <th>Rows</th>
                                <th>Filesize</th>
                                <th>Processed?</th>
                                <th>Imported?</th>
                                <th>Uploaded By</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {imports.map(item => (
                                <tr key={item.id}>
                                    <td>{item.id}</td>
                                    <td>
                                        <Link to={`/import/view/${item.id}`} onClick={toggle}>
                                            {item.name}
                                        </Link>
                                    </td>
                                    <td>{item.rowcount}</td>
                                    <td>{item.size}</td>
                                    <td>{item.is_processed}</td>
                                    <td>{item.is_imported}</td>
                                    <td>
                                        {item.created_by_user
                                            ? <span>{item.created_by_user.first_name} {item.created_by_user.last_name}<br/><small>{item.created_by_user.email}</small></span>
                                            : <span className="text-muted">Unknown</span>
                                        }
                                    </td>
                                    <td>{item.created_at ? new Date(item.created_at).toLocaleString() : '—'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <div className="text-end mt-2">
                        <Link to={`/import/list?config=${configId}`} onClick={toggle} className="btn btn-sm btn-outline-secondary">
                            View all →
                        </Link>
                    </div>
                    </>
                )}
            </ModalBody>
        </Modal>
    );
};

export default ImportHistoryModal;
